import React, { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import "./scss/AccordionDisplay.scss";

interface AccordionDisplayProps {
    visibility: boolean;
    children: React.ReactNode;
    dataUser?: Record<string, any>;
    autoComplete?: boolean;
    fields: string[];
}

const AccordionDisplay: React.FC<AccordionDisplayProps> = ({
    visibility,
    children,
    autoComplete = true,
    fields
}) => {

    const [flash, setFlash] = useState(false);
    const { watch, setValue, formState } = useFormContext();


    const initialValuesRef = useRef<Record<string, any> | null>(null);
    const watchedValues = watch(fields);

    /**
     *  valores iniciales inmediatamente después del RESET
     */
    useEffect(() => {
        if (!formState.defaultValues) return;

        
        const snapshot: Record<string, any> = {};

        fields.forEach(field => {
            snapshot[field] = watch(field); // valores post-reset
        });

        initialValuesRef.current = snapshot;
        //console.log("Valores post-reset:", snapshot);

    }, [formState.defaultValues]);


    /**
     * CONTROL DE VISIBILIDAD: poner null o restaurar valores
     */
    useEffect(() => {
        if (!autoComplete) return;
        if (!initialValuesRef.current) return;

        if (visibility) {
            // Restaurar valores iniciales guardados
            fields.forEach(field => {
                const value = initialValuesRef.current?.[field];
                setValue(field, value ?? null);
            });

        } else {
            // Poner a null al ocultar
            fields.forEach(field => {
                setValue(field, null);
            });
        }

    }, [visibility, autoComplete]);


    /**
     * Efecto visual flash
     */
    useEffect(() => {
        if (!visibility) return;

        setFlash(true);
        const t = setTimeout(() => setFlash(false), 1000);
        return () => clearTimeout(t);

    }, [visibility]);

    return (
        <div className={`accordion-display ${visibility ? "visible" : ""}`}>
            <div className={`accordion-display__content row ${flash ? "flash-border" : ""}`}>
                {children}
            </div>
        </div>
    );
};

export default AccordionDisplay;
